const baseCambixKycUrl =
  process.env.NEXT_PUBLIC_CAMBIX_KYC_URL ||
  process.env.EXPO_PUBLIC_CAMBIX_KYC_URL

const notabeneNodeUrl =
  process.env.NEXT_PUBLIC_NOTABENE_NODE_URL ||
  process.env.EXPO_PUBLIC_NOTABENE_NODE_URL

export const EXTERNAL_LINKS = {
  getCambixKycUrl: (token: string) => `${baseCambixKycUrl}/?token=${token}`,
  notabeneNodeUrl,
}

export const UNX_LINKS = {
  docs: 'https://docs.unx.com',
  faq: 'https://docs.unx.com/faq',
  terms: 'https://docs.unx.com/legal/terms-and-conditions',
  privacy: 'https://docs.unx.com/legal/privacy-policy',
  cookiePolicy: 'https://docs.unx.com/legal/cookie-policy',
  supportEmail: 'support@unx.com',
} as const
